import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CImagemComponent } from './c-imagem.component';

@NgModule({
  declarations: [CImagemComponent],
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  exports: [CImagemComponent],
})
export class CImagemModule {}
